import { IError, IFetchState } from "itsf-ui-common";
import { useCallback, useMemo, useState } from "react";

export const useFetchState = () => {
    const [state, setState] = useState<IFetchState>({ isLoading: false });

    const startFetching = useCallback(() => {
        setState({
            isLoading: true,
            error: undefined,
        });
    }, []);

    const endFetching = useCallback((error?: IError) => {
        if (error) {
            setState({
                isLoading: false,
                error,
            });
        } else {
            setState({
                isLoading: false,
            });
        }
    }, []);

    return useMemo(
        () => ({
            isLoading: state.isLoading,
            error: state.error,
            startFetching,
            endFetching,
        }),
        [startFetching, endFetching, state]
    );
};
